import { useState, useEffect, useRef } from "react";
import { useQueryState } from "nuqs";
import NavButton from "./NavButton";
import MainaIcon from "./MainaIcon";
import CardIcon from "./CardIcon";
import Card2Icon from "./Card2Icon";
import Certification from "./CertificationIcon";

function Nav({config}) {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const navRef = useRef(null);
  const [view, setView] = useQueryState('view', { defaultValue: 'mynaportal', history: 'push' });
  
  // Determine active tab based on view querystring
  const activeTab = (() => {
    if (view === 'mynaportal') return 'tab1';
    if (view === 'notification') return 'tab2';
    if (view === 'insurance-card') return 'tab3';
    if (view === 'qualification-certificate') return 'tab4';
    return 'tab1'; // default to mynaportal
  })();

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const handleClick = () => {
    if (isMobile && navRef.current ) {
      setTimeout(() => {
        navRef.current.scrollIntoView({ behavior: "smooth", block: "start" });
      }, 100);
    }
  }

  return (
    <div className="bg-modern-bgLight px-4 pt-0 pb-4 sm:pt-8 lg:px-8 lg:pb-8 mx-auto">
      <nav
        className="max-w-3xl mx-auto grid rounded-xl sm:flex sm:gap-x-4 gap-y-4 bg-white shadow-lg p-4"
        aria-label="Tabs"
        role="tablist"
        ref={navRef}
      >
        {config.show_oldcard && <button className="w-full" onClick={() => { setView('insurance-card'); handleClick(); }}>
          <NavButton
            isActive={activeTab === "tab3"}
            title="健康保険証"
            description=""
          >
            <CardIcon />
          </NavButton>
        </button>}
        {config.show_maina && <button className="w-full" onClick={() => { setView('mynaportal'); handleClick(); }}>
          <NavButton
            isActive={activeTab === "tab1"}
            title="マイナポータル"
            description=""
          >
            <MainaIcon />
          </NavButton>
        </button>}
        {config.show_newcard && <button className="w-full" onClick={() => { setView('qualification-certificate'); handleClick(); }}>
          <NavButton
            isActive={activeTab === "tab4"}
            title="資格確認書"
            description=""
          >
            <Card2Icon />
          </NavButton>
        </button>}
        {config.show_notification && <button className="w-full" onClick={() => { setView('notification'); handleClick(); }}>
          <NavButton
            isActive={activeTab === "tab2"}
            title="資格情報のお知らせ"
            description=""
          >
            <Certification />
          </NavButton>
        </button>}
      </nav>
    </div>
  );
}

export default Nav;
